import { DEFAULT_BORDER } from 'constants/global';

import First from 'assets/illustrations/cooperations/first.png';
import Second from 'assets/illustrations/cooperations/second.svg';
import Third from 'assets/illustrations/cooperations/third.svg';

const max = 3;
export const defaultCardsData = [
  {
    title: 'Расширение команды',
    description:
      'Позволяет быстро подключить к проекту необходимых технических специалистов. Мы подбираем кандидатов, которыми вы будете управлять',
    img: First,
    link: '/services/software-team-staff-augmentation',
  },
  {
    title: 'Выделенная команда',
    description:
      'Мы подбираем полную команду специалистов, которые будут выполнять проект под вашим управлением. При этом вы принимаете все решения и контролируете бюджет',
    img: Second,
    link: '/services/dedicated-team',
  },
  {
    title: 'Проектная разработка',
    description:
      'Мы реализуем проект, избавив вас от управленческой нагрузки. Специалисты ASTON запустят и проведут все этапы разработки',
    img: Third,
    link: '/services/managed-delivery',
  },
].map((cardData, i) => ({ ...cardData, pos: i + 1, max }));

const w = { laptop: '344px', mobile: '284px' };
const h = { laptop: '344px', mobile: '272px' };
const samePaddings = {
  laptop: '50px 120px 50px 80px',
  tablet: '24px 0px 24px 32px',
  mobile: '16px 24px',
};
export const defaultCardsStyles = {
  1: {
    imgProps: {
      w: { desktop: '554px', ...w },
      h: { desktop: '504px', ...h },
      mt: { tablet: '-20px', laptop: '-22px' },
    },
    p: { desktop: '48px 0px 48px 80px', ...samePaddings },
    sxCard: { bgColor: 'white', border: DEFAULT_BORDER, borderColor: 'bg.gray' },
  },
  2: {
    imgProps: {
      w: { desktop: '526px', ...w },
      h: { desktop: '504px', ...h },
      mt: { tablet: '-20px', laptop: '-10px', desktop: '-20px' },
    },
    sxCard: { bgColor: 'bg.gray' },
    p: { desktop: '48px 28px 48px 80px', ...samePaddings },
  },
  3: {
    imgProps: {
      w: { desktop: '526px', ...w },
      h: { desktop: '504px', ...h },
      mt: { tablet: '-20px', laptop: '-22px' },
    },
    sxCard: { bgColor: 'bg.accent' },
    p: { desktop: '48px 28px 48px 80px', ...samePaddings },
  },
};
